import * as types from '../mutation-types'

//建议对于getters,actions都加上模块名
// initial state
const state = {
  currentView: '', //当前打开的视图,
  tabItems: [], //所有打开的视图列表
  tabItemMap: {}
}

// getters
const getters = {
  frameworktabs_currentView: state => state.currentView, //获取当前的视图
  frameworktabs_tabItems: state => state.tabItems //获取所有打开的视图列表
}

// actions
const actions = {
  //add tab action
  frameworktabsAddTab({ commit, state }, tabItem_) {
    commit(types.FRAMEWORKTABS_ADD_TABITEM, tabItem_);
  },
  //激活视图
  frameworktabsActiveTab({ commit, state }, tabItemView_) {
    commit(types.FRAMEWORKTABS_ACTIVE_TABITEM, tabItemView_);
  },
  //去激活视图
  frameworktabsUnActiveTab({ commit, state }, tabItemView_) {
    commit(types.FRAMEWORKTABS_UNACTIVE_TABITEM, tabItemView_);
  }  
}

// mutations
const mutations = {
  //新增tabItem
  [types.FRAMEWORKTABS_ADD_TABITEM] (state, tabItem_) {
      const component_ = tabItem_.component;
      state.currentView = component_;
      console.log('component_:' + component_);
      const curTabItem_ = state.tabItemMap[component_];
      console.log('curTabItem_:' + curTabItem_);
      if(!curTabItem_) {
        //不存在，需要新增
        state.tabItems.push(tabItem_);
        state.tabItemMap[component_] = component_;
      }
  },
  //激活视图
  [types.FRAMEWORKTABS_ACTIVE_TABITEM] (state, tabItemView_) {
      state.currentView = tabItemView_;
  },
  //去激活视图
  [types.FRAMEWORKTABS_UNACTIVE_TABITEM] (state, tabItemView_) {
      //所有打开视图中移除(并激活当前视图左边的或者右边第一个)
      const tabItems_ = state.tabItems;
      const tabItemMap_ = state.tabItemMap;
      let delItem_, index;
      for (index = 0; index < tabItems_.length; index++) {
        const tabItem_ = tabItems_[index];
        const component_ = tabItem_.component;
        if(component_ == tabItemView_) {
          console.log('--remove---' + component_);
          delItem_ = tabItem_;
          tabItems_.splice(index, 1);
          delete tabItemMap_[component_];  
          break;
        }
      }
      let tabItems_length = tabItems_.length;
      if(delItem_.component == state.currentView) {
        //需要找到其上一个显示或者下一个显示
        console.log('currIndex:' + index);
        if(0 == tabItems_length) {
          state.currentView = '';
          return;
        }
        let vIndex = (index > 0 ? index -1 : 0);
        console.log('vIndex:' + vIndex);
        let vTabItem_ = tabItems_[vIndex];
        state.currentView = vTabItem_.component;
      }
      console.log(delItem_.component)
  }  
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/frameworktabs.js